export const DEDUPLICATION_SOURCE_ONE_FIELD_PARAM = 'sourceOneField' as const;
export const DEDUPLICATION_SOURCE_ONE_VALUE_PARAM = 'sourceOneValue' as const;
export const DEDUPLICATION_SOURCE_TWO_FIELD_PARAM = 'sourceTwoField' as const;
export const DEDUPLICATION_SOURCE_TWO_VALUE_PARAM = 'sourceTwoValue' as const;
